var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.932 21.338h-4.507L24.445 8H31l-9.788 9.788-.91-.547-4.37 4.098zm4.37-2.458 4.143 4.416h-8.24l4.097-4.416zm-8.604-6.328L7.555 8.137h8.24l-4.097 4.415zm4.37-2.458h4.507L7.555 23.433H1l9.788-9.788.91.546 4.37-4.096z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNye);
export default __webpack_public_path__ + "static/media/NYE.f3d84eba698da83fe11fb649adaf3c32.svg";
export { ForwardRef as ReactComponent };